import { useRef, useState } from "react";
import { toast } from "sonner";
import { inspectionApi } from "./api";
import { buildPhotoForm } from "./capture";

export const ShotCard = ({ inspectionId, roomKey, shot, photoIds = [], onUploaded, locked = false }) => {
  const input = useRef(null);
  const fileInput = useRef(null);
  const [busy, setBusy] = useState(false);
  const done = photoIds.length > 0;
  const tid = `insp-shot-${roomKey}-${shot.key}`;

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const { form, gps } = await buildPhotoForm({ file, roomKey, shotKey: shot.key });
      const res = await inspectionApi.upload(inspectionId, form);
      onUploaded(roomKey, shot.key, res.photo.photo_id);
      toast.success(`Vaulted · SHA-256 ${res.photo.sha256.slice(0, 10)}…${gps ? "" : " · no GPS fix"}`);
    } catch (err) {
      toast.error(err.message || "Upload failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={`insp-shot ${done ? "insp-shot--done" : ""}`} data-testid={tid}>
      <div className="insp-shot__head">
        <span className={`insp-shot__check ${done ? "on" : ""}`}>{done ? "✓" : ""}</span>
        <div className="insp-shot__text">
          <div className="insp-shot__label">
            {shot.label}
            {shot.required ? <span className="insp-req">Required</span> : <span className="insp-opt">Optional</span>}
          </div>
          <div className="insp-shot__tip">{shot.tip}</div>
        </div>
      </div>
      {photoIds.length > 0 && (
        <div className="insp-thumbs">
          {photoIds.map((pid) => (
            <img key={pid} src={inspectionApi.photoUrl(pid)} alt={shot.label} className="insp-thumb" data-testid={`insp-thumb-${pid}`} />
          ))}
        </div>
      )}
      <input ref={input} type="file" accept="image/*" capture="environment" hidden onChange={onFile} data-testid={`${tid}-input`} />
      <input ref={fileInput} type="file" accept="image/*" hidden onChange={onFile} data-testid={`${tid}-file-input`} />
      {locked ? (
        <button type="button" className="insp-btn insp-btn--capture" disabled data-testid={`${tid}-capture`}>Locked</button>
      ) : (
        <div className="insp-shot__actions">
          <button type="button" className="insp-btn insp-btn--capture" disabled={busy} onClick={() => input.current?.click()} data-testid={`${tid}-capture`}>
            {busy ? "Vaulting…" : done ? "Take another photo" : "Take photo"}
          </button>
          <button type="button" className="insp-btn insp-btn--upload" disabled={busy} onClick={() => fileInput.current?.click()} data-testid={`${tid}-upload`}>
            Upload photo
          </button>
        </div>
      )}
    </div>
  );
};
